import styled from 'styled-components';

// Base container
export const ContainerBase = styled.div`
    width: 100%;
    margin: 0 auto auto;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 25px;
`;
